import React, { useCallback, useEffect, useState } from "react";
import EmailsHistory from "../../../Common/AutoSuggestion/Email-History-Page/EmailsHistory";
import mailIcon from "../../../Assets/Images/client-email-icon.svg";
import { post } from "../../../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  VENDOR_EMAIL_HISTORY,
} from "../../../helper/url_helper";

const EMAIL_HISTORY_LIMIT = 20;

function VendorEmailHistory({ selectedVendor, onHasEmailHistoryChange }) {
  const [emailHistory, setEmailHistory] = useState([]);
  const [totalLogs, setTotalLogs] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const vendorId = selectedVendor?.id || selectedVendor?.vendor_id;

  const fetchEmailHistoryData = useCallback(async () => {
    if (!vendorId) {
      setEmailHistory([]);
      setTotalLogs(0);
      onHasEmailHistoryChange?.(false);
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        vendor_id: vendorId,
        offset: 0,
        limit: EMAIL_HISTORY_LIMIT,
      };
      const emailHistoryResponse = await post(
        VYLABS_BASE_URL,
        VENDOR_EMAIL_HISTORY,
        payload,
      );
      const emailLogs = Array.isArray(emailHistoryResponse?.email_logs)
        ? emailHistoryResponse.email_logs
        : [];

      setEmailHistory(emailLogs);
      setTotalLogs(
        typeof emailHistoryResponse?.total_logs === "number"
          ? emailHistoryResponse.total_logs
          : emailLogs.length,
      );
      onHasEmailHistoryChange?.(emailLogs.length > 0);
    } catch (error) {
      console.error("Error fetching vendor email history:", error);
      setEmailHistory([]);
      setTotalLogs(0);
      onHasEmailHistoryChange?.(false);
    } finally {
      setIsLoading(false);
    }
  }, [vendorId, onHasEmailHistoryChange]);

  useEffect(() => {
    fetchEmailHistoryData();
  }, [fetchEmailHistoryData]);

  return (
    <EmailsHistory
      emailHistory={emailHistory}
      totalLogs={totalLogs}
      isLoading={isLoading}
      entityLabel="vendor"
      mailIcon={mailIcon}
      defaultVariant="client"
    />
  );
}

export default VendorEmailHistory;
